import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'LINEARREG_SLOPE',
  version: 1,
  label: 'Linear Regression Slope',
  pane: 'sub',
  category: 'statistics',
  series: 'price',
  order: 30,
  inputs: [period('timeperiod', 14)],
  outputs: [line('slope', 'Slope', COLOR.blue)],
  levels: [{ value: 0 }],
  talib: { functions: ['LINEARREG_SLOPE'], expr: 'LINEARREG_SLOPE(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
